<template>
  <div>
    <!-- title bar -->
    <div class="title">
      <div class="container lg">
        <div class="right">
          <i class="fad fa-user-astronaut text-accent"></i
          >{{ onlineUsers + 200 }}
          {{ $t("online") }}
        </div>

        <div class="left">
          <span v-if="isConnected">
            <i class="fad fa-signal text-connect"></i> {{ $t("Connected") }}
          </span>
          <span v-else>
            <i class="fad fa-signal-alt-slash"></i>
            {{ $t("Disconnect") }}
          </span>
        </div>
      </div>
    </div>
    <!--  -->

    <div class="container-center lg">
      <!-- 8 menu  -->
      <div class="panel panel-b-dark">
        <div class="panel-body">
          <div class="divTable m-t-xs menu">
            <div class="divTableBody">
              <div class="divTableRow">
                <div class="divTableCell">
                  <div class="col-xs-3">
                    <router-link
                      to="/news"
                      class="btn btn-accent btn-block text-accent"
                      tag="button"
                    >
                      <span class="m-t-sm fad fa-newspaper fa-2x"></span>
                      <p>{{ $t("News") }}</p>
                    </router-link>
                  </div>

                  <div class="col-xs-3">
                    <router-link
                      to="/referral"
                      class="btn btn-accent btn-block text-accent"
                      tag="button"
                    >
                      <span class="m-t-sm fad fa-share-alt fa-2x"></span>
                      <p>{{ $t("Referral") }}</p>
                    </router-link>
                  </div>
                  <div class="col-xs-3">
                    <a
                      class="btn btn-accent btn-block text-accent"
                      target="_blank"
                      href="https://t.me/uk_365stream/"
                      tag="button"
                    >
                      <span class="m-t-sm fad fa-comments-dollar fa-2x"></span>
                      <p>{{ $t("Chat") }}</p>
                    </a>
                  </div>
                  <div class="col-xs-3">
                    <router-link
                      to="/support"
                      class="btn btn-accent btn-block text-accent"
                      tag="button"
                    >
                      <span class="m-t-sm fad fa-phone fa-2x"></span>
                      <p>{{ $t("Support") }}</p>
                    </router-link>
                  </div>

                  <div class="col-xs-3">
                    <router-link
                      to="/fee"
                      class="btn btn-accent btn-block text-accent"
                      tag="button"
                    >
                      <span class="m-t-sm fad fa-comment-dollar fa-2x"></span>
                      <p>{{ $t("Fees") }}</p>
                    </router-link>
                  </div>

                  <div class="col-xs-3">
                    <router-link
                      to="/listing"
                      class="btn btn-accent btn-block text-accent"
                      tag="button"
                    >
                      <span class="m-t-sm fad fa-server fa-2x"></span>
                      <p>{{ $t("CoinsDetail") }}</p>
                    </router-link>
                  </div>
                  <div class="col-xs-3">
                    <router-link
                      to="/api"
                      class="btn btn-accent btn-block text-accent"
                      tag="button"
                    >
                      <span class="m-t-sm fad fa-code fa-2x"></span>
                      <p>{{ $t("API") }}</p>
                    </router-link>
                  </div>
                  <div class="col-xs-3">
                    <router-link
                      to="/language"
                      class="btn btn-accent btn-block text-accent"
                      tag="button"
                    >
                      <span class="m-t-sm fad fa-language fa-2x"></span>
                      <p>{{ $t("Language") }}</p>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->

      <!-- Big slider picture -->

      <!--  -->

      <!-- tab for select market  -->
      <h4 class="m-l-sm">Market</h4>
      <div class="topmarket">
        <div class="tophead text-center">
          <div class="col-xs-6 active" v-if="market == 'STAR'">
            <p class="pointer"><i class="fad fa-star"></i></p>
          </div>
          <div class="col-xs-6" v-else v-on:click="market = 'STAR'">
            <p class="pointer"><i class="fad fa-star"></i></p>
          </div>
          <div class="col-xs-6 active" v-if="market.indexOf('USD') > -1">
            <p class="pointer">USD<i class="m-l-xs fad fa-dollar-sign"></i></p>
          </div>
          <div class="col-xs-6" v-else v-on:click="market = 'USD'">
            <p class="pointer">USD<i class="m-l-xs fad fa-dollar-sign"></i></p>
          </div>
        </div>
      </div>
      <!--  -->

      <div class="market" v-if="getMarket">
        <div class="divTable">
          <div class="divTableHeading">
            <div class="divTableRow">
              <div class="divTableHead width-pair">
                {{ $t("Name") }}
                <router-link to="/favorite" v-if="market == 'STAR'">
                  <i class="far fa-star-half-alt"></i
                  ><i class="fad fa-marker m-l-n-xxs"></i>
                </router-link>
              </div>
              <div class="divTableHead width-price">
                {{ $t("LastPrice") }}
              </div>
              <div class="divTableHead text-center width-change">
                {{ $t("hChg") }}
              </div>
            </div>
          </div>
          <div class="divTableBody" v-for="m in getMarket" v-bind:key="m.pair">
            <router-link
              v-bind:to="'/' + getSitemode + '/' + m.pair"
              tag="div"
              class="divTableRow marketList"
              v-if="
                m.primary.indexOf(market) > -1 ||
                (market == 'STAR' && starMarket[m.pair])
              "
            >
              <div class="divTableCell width-pair">
                <h4>
                  <img
                    :src="require(`@/assets/tokens/${m.secondary}.png`)"
                    class="coin"
                  />
                  {{ m.primary }} /
                  <span class="font-bold c-white"> {{ m.secondary }}</span>
                </h4>
                <span class="fav"
                  >{{ $t("Vol") }} ${{ fixed(m.amount_24hrs) }}</span
                >
              </div>

              <div class="divTableCell width-price">
                <transition name="list" mode="out-in">
                  <h4 class="font-bold c-white list" :key="m.last_price">
                    {{ digit(m.last_price, m.rate_digi) }}
                  </h4>
                </transition>
                {{ $t("avg") }} {{ digit(m.average, m.rate_digi) }}
              </div>

              <div class="divTableCell width-change">
                <span
                  href="#"
                  class="btn btn-muted btn-block c-white font-bold"
                  v-if="m.change / 1 == 0"
                  >0.00%</span
                >
                <span
                  href="#"
                  class="btn btn-buy btn-block c-white font-bold"
                  v-else-if="m.change / 1 > 0"
                  >+{{ m.change }}%</span
                >
                <span
                  href="#"
                  class="btn btn-sell btn-block c-white font-bold"
                  v-else
                  >{{ m.change }}%</span
                >
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//       <h4 class="m-l-sm">What's New</h4>
//       <flickity ref="flickity" :options="flickityOptions">
//         <div
//           v-for="f in flickitySlide"
//           :key="f.id"
//           :class="f.class"
//           :style="f.style"
//         ></div>
//       </flickity>

// import Flickity from "vue-flickity";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    // Flickity,
  },
  data() {
    return {
      market: "USD",
      starMarket: JSON.parse(localStorage.getItem("StarMarket")),
      flickitySlide: [
        {
          class: "carousel-cell",
          style: "background-image: url(/img/11.jpg);",
        },
        {
          class: "carousel-cell",
          style: "background-image: url(/img/10.png);",
        },
        {
          class: "carousel-cell",
          style: "background-image: url(/img/9.png);",
        },
        {
          class: "carousel-cell",
          style: "background-image: url(/img/8.png);",
        },
        {
          class: "carousel-cell",
          style: "background-image: url(/img/7.png);",
        },
        {
          class: "carousel-cell",
          style: "background-image: url(/img/6.jpg);",
        },
        {
          class: "carousel-cell",
          style: "background-image: url(/img/5.png);",
        },
        {
          class: "carousel-cell",
          style: "background-image: url(/img/4.jpg);",
        },
        {
          class: "carousel-cell",
          style: "background-image: url(/img/3.jpg);",
        },
        {
          class: "carousel-cell",
          style: "background-image: url(/img/2.jpg);",
        },
        {
          class: "carousel-cell",
          style: "background-image: url(/img/1.jpg);",
        },
      ],
      flickityOptions: {
        autoPlay: 1500,
        initialIndex: 2,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        dragThreshold: 10,
      },
    };
  },
  computed: mapGetters([
    "onlineUsers",
    "isConnected",
    "getSitemode",
    "getMarket",
    "getPairing",
  ]),
  methods: {
    ...mapActions(["setOnlines", "fetchMarket"]),
    fixed(a) {
      return (a.toFixed(0) / 1).toLocaleString();
    },
    digit(a, digi) {
      if (a) {
        return a.toLocaleString(undefined, {
          minimumFractionDigits: digi,
        });
      }
    },
  },
  created() {
    this.setOnlines();
    this.fetchMarket();
    this.starMarket = JSON.parse(localStorage.getItem("StarMarket"));
  },
};
</script>

<style scoped>
.text-connect {
  color: #97c378;
}

.container-center {
  padding: 0 0 13px 0;
}
.panel {
  margin: 45px 10px 10px 10px;
  border-radius: 6px;
}
.panel .panel-body {
  padding: 0px;
}
.btn {
  font-size: 15px;
}
.btn:hover {
  color: #ffffff;
}
.btn-accent {
  border-color: transparent;
}
.menu .col-xs-3 {
  padding-left: 0px;
  padding-right: 0px;
}
.menu .btn {
  padding: 0px;
}
.carousel-cell {
  width: 80%;
  margin-right: 10px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: 50% 50%;
  padding-bottom: 31%;
  border-radius: 5px;
}
.carousel-cell:before {
  display: block;
  text-align: center;
  line-height: 200px;
  font-size: 80px;
}

.topmarket {
  padding-top: 5px;
  position: static;
  width: 100%;
  height: 33px;
  background-color: #1d1f24;
  z-index: 10;
  margin-bottom: 0px;
}
.active p {
  padding-bottom: 5px;
  color: #f6a821;
  border-bottom-color: #f6a821;
  border-bottom: solid;
  margin: 0 0 5px;
}
.market {
  display: block;
  top: -5px;
  padding: 0 0 65px 0;
  position: relative;
  width: 100%;
}
.market .divTableCell {
  border-bottom: 0.5px solid #434039;
  vertical-align: middle;
  padding: 5px;
}
.divTableHeading .divTableRow {
  background-color: #444953;
}
.divTableCell,
.divTableHead {
  width: 33.33333%;
  border: 0px solid #3d404c;
}

.divTableBody .divTableRow:hover {
  cursor: pointer;
}
.width-pair {
  min-width: 160px;
}
.width-price {
  min-width: 100px;
}
.width-change {
  min-width: 100px;
}

.list-enter-active,
.list-leave-active {
  color: #f6a821;
  transition-duration: 0.3s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  color: #f6a821;
  transition-duration: 0.3s;
}
.coin {
  height: 20px;
}
</style>
